const config = {
  env: import.meta.env.VITE_ENV,
  apiUrl: import.meta.env.VITE_API_URL,
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    redirectUri: import.meta.env.VITE_ENV === 'development' 
      ? 'http://localhost:3000/callback'
      : `${window.location.origin}/callback`
  },
  posthog: {
    apiKey: import.meta.env.VITE_POSTHOG_API_KEY,
    host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com'
  },
  limits: {
    maxQuestions: import.meta.env.VITE_MAX_QUESTIONS ? parseInt(import.meta.env.VITE_MAX_QUESTIONS, 10) : null
  }
};

export default config; 